import React from "react";
import { AutoplayProvider } from "../AutoplayContext/AutoplayProvider";
import { VideoAnalyticsProvider } from "../VideoAnalyticsContext";
import PropTypes from "prop-types";
import { VideoPerformanceProvider } from "../PerformanceContext";
import { HlsProvider } from "../HlsContext/HlsProvider";
import { IntersectionProvider } from "../IntersectionContext/IntersectionProvider";

// This component builds the minimal stack of providers needed by the looping player.
export const LoopingFeatureStack = ({ children, config, orcaDeps = {} }) => {
  const { Hls } = orcaDeps;

  return (
    <HlsProvider Hls={Hls} config={config}>
      <AutoplayProvider {...{ config }}>
        <IntersectionProvider>
          <VideoAnalyticsProvider {...{ config }}>
            <VideoPerformanceProvider {...{ config }}>
              {children}
            </VideoPerformanceProvider>
          </VideoAnalyticsProvider>
        </IntersectionProvider>
      </AutoplayProvider>
    </HlsProvider>
  );
};

LoopingFeatureStack.propTypes = {
  children: PropTypes.node.isRequired,
  config: PropTypes.object,
  orcaDeps: PropTypes.shape({
    Hls: PropTypes.object
  })
};
